<mat-dialog-content>
    <h2>Select new Zoning Code</h2>
    <mat-form-field style="width: 100%"> <!-- TODO: Move to class -->
        <mat-select placeholder="Pick Zoning Code" [(value)]="selectedZoningCode" [panelWidth]="'400px'">
            <mat-option *ngFor="let code of zoningCodes | async" [value]="code">{{code.Name}}</mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="primary" style="width: 100%" [mat-dialog-close]="selectedZoningCode">Add Zoning
        Code</button>
</mat-dialog-actions>